var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1547 20.5C7.56091 20.5 4.27966 18.625 2.48279 15.5C0.685913 12.4141 0.685913 8.625 2.48279 5.5C4.27966 2.41406 7.56091 0.5 11.1547 0.5C14.7094 0.5 17.9906 2.41406 19.7875 5.5C21.5844 8.625 21.5844 12.4141 19.7875 15.5C17.9906 18.625 14.7094 20.5 11.1547 20.5ZM11.1547 5.5C10.6078 5.5 10.2172 5.92969 10.2172 6.4375V10.8125C10.2172 11.3594 10.6078 11.75 11.1547 11.75C11.6625 11.75 12.0922 11.3594 12.0922 10.8125V6.4375C12.0922 5.92969 11.6625 5.5 11.1547 5.5ZM9.90466 14.25C9.90466 14.9531 10.4515 15.5 11.1547 15.5C11.8187 15.5 12.4047 14.9531 12.4047 14.25C12.4047 13.5859 11.8187 13 11.1547 13C10.4515 13 9.90466 13.5859 9.90466 14.25Z",
    fill: "#E2001A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.328f28693d0755ed64cba6d9f4b3e8b9.svg";
export { ForwardRef as ReactComponent };